import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface AddStarPointsInterface {
  date: string;
}

export const useGetDashboardStatsForEarnings = () => {
  const mutate = useMutation(({ date }: AddStarPointsInterface) => {
    return get(`/earnings-api/get_monthly_earnings_bydate`);
  });

  return mutate;
};

export default useGetDashboardStatsForEarnings;
